<template>
<div class="microPageEdit">
    <mobileheader :class="{'slick-select': selectIndex === -1}" @click.native="compSelectedHeader"></mobileheader>
    <SlickList lockAxis="y" v-model="item.complist" @sort-start="sortStart" @sort-end="sortEnd"  @sort-move="sortMove" class="slickList"
               :distance="5"  @input="getChangeLists" :lockToContainerEdges="true">
        <SlickItem v-for="(obj, index) in item.complist" :index="index"  :key="index"
                   helper-class="listSelect"  class="slickItem" :class="{'slick-select': selectIndex === index}"
                   @click.native="compSelected(obj, index, $event)">
            <div class="itemBox" ref="itemBox">
                <component :is="item.clienttype+obj.comtype" :setting="obj"></component>
                <div class="compBtn">
                    <span class="el-icon-circle-plus addComp cursor operateComp" @click.stop="OpenCompAdd(index, $event)"></span>
                    <span class="el-icon-error delComp cursor operateComp" @click.stop="compDel(index)"></span>
                </div>
                <div class="mask"></div>
            </div>
        </SlickItem>
    </SlickList>
    <shopMobCompList ref="shopMobCompList" @setNewCompTop="_setNewCompTop"></shopMobCompList>
    <div style="text-align: center;margin-top:20px ">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitComp">保存</el-button>
    </div>
    <shopMobCompList ref="compMenu" class="compMenu" :style="'top:'+ top" v-show="isShow" @setNewCompTop="_setNewCompTop"></shopMobCompList>
    <component :is="item.clienttype + selectCom.name + 'setting'" :style="'top:'+ top" v-if="selectCom.name && selectCom.name != 'searchbar'"></component>
    <!-- <component :is="item.clienttype + obj.name + 'setting'" :ref="item.clienttype + obj.name + 'setting' + index" :style="'top:'+ top" v-for="(obj, index) in settingList" :key="index" v-show="selectCom.name && selectCom.name != 'searchbar'"></component> -->
</div>
</template>
<script>
import {getMicroPageView, editMicroPage} from 'api/api'
import {SlickList, SlickItem} from 'vue-slicksort'
import {mobDataValidate} from 'views/shopMgt/mob/page/js/shopDataValidate'
import ShopMobCompList from 'views/shopMgt/mob/page/components/shopMobCompList'
import {mapGetters, mapActions} from 'vuex'
import ShopMobBanner from 'views/shopMgt/mob/page/components/shopMobBanner'
import ShopMobBannerSetting from 'views/shopMgt/mob/page/setting/shopMobBannerSetting'
import ShopMobTop from 'views/shopMgt/mob/page/components/shopMobTop'
import ShopMobTopSetting from 'views/shopMgt/mob/page/setting/shopMobTopSetting'
import ShopMobKnowledge from 'views/shopMgt/mob/page/components/shopMobKnowledge'
import ShopMobKnowledgeSetting from 'views/shopMgt/mob/page/setting/shopMobKnowledgeSetting'
import ShopMobVlive from 'views/shopMgt/mob/page/components/shopMobVlive'
import ShopMobVliveSetting from 'views/shopMgt/mob/page/setting/shopMobVliveSetting'
import ShopMobActivity from 'views/shopMgt/mob/page/components/shopMobActivity'
import ShopMobActivitySetting from 'views/shopMgt/mob/page/setting/shopMobActivitySetting'
import ShopMobNavigation from 'views/shopMgt/mob/page/components/shopMobNavigation'
import ShopMobNavigationSetting from 'views/shopMgt/mob/page/setting/shopMobNavigationSetting'
import ShopMobStar from 'views/shopMgt/mob/page/components/shopMobStar'
import ShopMobStarSetting from 'views/shopMgt/mob/page/setting/shopMobStarSetting'
import ShopMobCoupon from 'views/shopMgt/mob/page/components/shopMobCoupon'
import ShopMobCouponSetting from 'views/shopMgt/mob/page/setting/shopMobCouponSetting'
import ShopMobStarSearch from 'views/shopMgt/mob/page/components/shopMobSearch'
import ShopMobStarSubject from 'views/shopMgt/mob/page/components/shopMobStarSubject'
import ShopMobStarSubjectSetting from 'views/shopMgt/mob/page/setting/shopMobStarSubjectSetting'
import $ from 'jquery'
export default {
    name: 'microPageEdit',
    data() {
        return {
            item: {
                pageinnerid: this.$route.query.id ? this.$route.query.id : '',
                clienttype: 'mobile',
                pagename: '页面名称',
                isdefault: 0,
                complist: []
            },
            selectIndex: 0,
            top: '0px',
            offset: 0,
            isShow: false,
            styleObject: {
                display: this.$route.query.model === 1 ? 'none' : 'block'
            }
        }
    },
    mounted() {
        if (this.item.pageinnerid) {
            this._getView()
        } else {
            this.setShopMob(this.item.complist)
            this.item.isdefault = this.$route.query.type ? 1 : 0
        }
        // this.$refs.shopMobCompList.openCompAdd()
        this.modelJoin()
    },
    updated() {
    },
    destroyed() {
        this.setShopMob([])
        this.setSelectCom({index: 0, name: ''})
    },
    methods: {
        // 模板加载
        modelJoin() {
            let arr = []
            let arr2 = []
            if (this.$route.query.model) {
                this.setLoading(true)
                // 模板1
                if (sessionStorage.modelid === '001') {
                    arr = ['searchbar', 'imagead', 'categorynav', 'knowledge', 'activity', 'coupon']
                    arr.forEach((item, index) => {
                        this.$refs.shopMobCompList.shopCompList.forEach((obj) => {
                            if (obj.comp.comtype === item) {
                                if (obj.comp.comtype === 'categorynav') {
                                    obj.comp.datacount = 4
                                }
                                if (obj.comp.comtype === 'knowledge') {
                                    obj.comp.titlename = '知识店铺'
                                }
                                arr2.push(obj.comp)
                            }
                        })
                    })
                } else if (sessionStorage.modelid === '002') { // 模板2
                    arr = ['searchbar', 'imagead', 'categorynav', 'knowledge', 'star']
                    arr.forEach((item, index) => {
                        this.$refs.shopMobCompList.shopCompList.forEach(obj => {
                            if (obj.comp.comtype === item) {
                                if (obj.comp.comtype === 'categorynav') {
                                    obj.comp.datacount = 4
                                }
                                if (obj.comp.comtype === 'knowledge') {
                                    obj.comp.liststyle = 'smallimage'
                                    obj.comp.titlename = '知识商品'
                                }
                                arr2.push(obj.comp)
                            }
                        })
                    })
                } else if (sessionStorage.modelid === '003') { // 模板3
                    arr = ['searchbar', 'imagead', 'categorynav', 'starsubject']
                    arr.forEach((item,index) => {
                        this.$refs.shopMobCompList.shopCompList.forEach(obj => {
                            if (obj.comp.comtype === item) {
                                if (obj.comp.comtype === 'categorynav') {
                                    obj.comp.datacount = 4
                                }
                                if (obj.comp.comtype === 'starsubject') {
                                    obj.comp.datacount = 10
                                    obj.comp.titlename = '精选帖子'
                                }
                                arr2.push(obj.comp)
                            }
                        })
                    })
                }
            }
            this.item.complist = arr2
            this.setShopMob(this.item.complist)
            this.setLoading(false)
        },
        compSelectedHeader() {
            this.setSelectCom({index: -1, name: 'header'})
            this.selectIndex = -1
        },
        cancel() {
            this.$router.back()
        },
        submitComp() {
            let [flag, tmpList] = mobDataValidate(this.item.complist)
            if (flag) {
                let tmpObj = $.extend(true, {}, this.item)
                tmpObj.pagename = this.smallPageName
                tmpObj.complist = tmpList
                console.log(JSON.stringify(tmpObj))
                editMicroPage({
                    data: {
                        pagejson: JSON.stringify(tmpObj)
                    },
                    success: data => {
                        this.$message.success('保存成功！')
                        this.setSelectCom({index: null, name: ''})
                        this.setLoading(false)
                        this.cancel()
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }
        },
        // 删除组件
        compDel(index) {
            // this.$refs.compMenu.closeCompAdd()
            this.isShow = false
            let tmpList = Object.assign([], this.shopMob)
            tmpList.splice(index, 1)
            this.setShopMob(tmpList)
            this.setSelectCom({index: 0, name: ''})
        },
        // 打开组件增加框
        OpenCompAdd(index, event) {
            this.setSelectCom({index: index, name: ''})
            this.$refs.compMenu.openCompAdd()
            this.isShow = true
            let top = $(event.target).parent().parent()[0].offsetTop
            this.top = `${top}px`
        },
        _setNewCompTop(flag, index) {
            this.isShow = flag
            this.$nextTick(() => {
                let top = $('.slickList > .slickItem')[index].offsetTop
                this.top = `${top}px`
            })
        },
        // 选中组件
        compSelected(obj, index, event) {
            this.selectIndex = index
            if (!this.selectCom.name || this.selectCom.index !== index) {
                this.setSelectCom({index: index, name: obj.comtype})
            }
            // this.$refs.compMenu.closeCompAdd()
            this.isShow = false
            let top = $(event.target).parent().parent()[0].offsetTop
            this.top = `${top}px`
            console.log(top)
        },
        sortStart(event) { // event, node, index, collection
            $('.compBtn').hide()
            // this.$refs.compMenu.closeCompAdd()
            this.isShow = false
            this.offset = event.event.pageY - $(event.node).offset().top - $('.shopMobTop').height()
            this.setSelectCom({index: event.index, name: this.item.complist[event.index].comtype})
        },
        sortMove(event) {
            let top = event.event.offsetY - this.offset
            this.top = `${Math.abs(top)}px`
        },
        sortEnd(event) { // event, newIndex, oldIndex, collection
            this.selectIndex = event.newIndex
            $('.compBtn').show()
        },
        // 获取更改顺序后的数组
        getChangeLists(vals) {
            this.setShopMob(Object.assign([], vals))
            this.$nextTick(() => {
                let top = $('.microPageEdit .slickList').find('.slickItem')[this.selectIndex].offsetTop
                this.top = `${top}px`
                // $('.knowledgeSetting').animate({top: `${top}px`}, 300)
            })
            this.setSelectCom({index: this.selectIndex, name: this.item.complist[this.selectIndex].comtype})
        },
        _getView() {
            this.setLoading(true)
            getMicroPageView({
                data: {
                    pageinnerid: this.item.pageinnerid
                },
                success: data => {
                    data.data.complist.forEach(obj => {
                        obj.isdisplayall = obj.isdisplayall ? true : false
                    })
                    this.item = data.data
                    this.setShopMob(Object.assign([], this.item.complist))
                    this.setSmallPageName(this.item.pagename)
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setShopMob',
            'setSelectCom',
            'setSmallPageName'
        ])
    },
    watch: {
        shopMob: {
            handler: function() {
                this.item.complist = Object.assign([], this.shopMob)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'shopMob',
            'selectCom',
            'smallPageName'
        ])
    },
    components: {
        SlickList,
        SlickItem,
        ShopMobCompList,
        mobileheader: ShopMobTop,
        mobileheadersetting: ShopMobTopSetting,
        mobileimagead: ShopMobBanner,
        mobileimageadsetting: ShopMobBannerSetting,
        mobileknowledge: ShopMobKnowledge,
        mobileknowledgesetting: ShopMobKnowledgeSetting,
        mobilealive: ShopMobVlive,
        mobilealivesetting: ShopMobVliveSetting,
        mobileactivity: ShopMobActivity,
        mobileactivitysetting: ShopMobActivitySetting,
        mobilecategorynav: ShopMobNavigation,
        mobilecategorynavsetting: ShopMobNavigationSetting,
        mobilestar: ShopMobStar,
        mobilestarsetting: ShopMobStarSetting,
        mobilecoupon: ShopMobCoupon,
        mobilecouponsetting: ShopMobCouponSetting,
        mobilesearchbar: ShopMobStarSearch,
        mobilestarsubject: ShopMobStarSubject,
        mobilestarsubjectsetting: ShopMobStarSubjectSetting
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.microPageEdit{
    margin-top: 10px;
    position: relative;
    width: 15rem;
    padding-left: 300px;
    .slickList{
        min-height: 900px;
        background: $bgcolor-white;
        box-shadow:0px 0px 6px 2px rgba(1, 44, 84, 0.05);
        .slickItem{
            cursor: move;
            min-height: 50px;
            box-sizing: border-box;
            margin-bottom:10px;
            border: 2px solid $line;
        }
        .slick-select{
            border: 2px dashed $tcolor-blue;
            box-sizing: border-box;
        }
        .slickItem:hover{
            box-sizing: border-box;
            border: 2px solid $tcolor-blue;
            .addComp,.delComp{
                display: inline-block;
            }
        }
    }
    .listSelect{
        background: red;
        .slickItem{
            background: red;
        }
    }
    .compMenu{
        position: absolute;
        left: calc(100% + 10px);
        top:0;
        width: 375px;
    }
}
.slick-select{
    border: 2px dashed $tcolor-blue;
    box-sizing: border-box;
}
.itemBox{
    box-sizing: border-box;
    position: relative;
    background: $bgcolor-white;
    .operateComp{
        display: none;
        position: absolute;
        z-index: 100;
        top: -10px;
        font-size: 20px;
        z-index: 3;
    }
    .addComp{
        color: $tcolor-blue;
        left: calc(50% - 10px);
    }
    .delComp{
        color: $tcolor-grey;
        left: calc(100% - 10px);
    }
    .mask{
        position: absolute;
        top:0;
        left:0;
        bottom: 0;
        right:0;
        z-index: 2;
    }
}
</style>
